//@ts-ignore
import * as Sentry from "@sentry/browser";

const sessionId = Math.random().toString(16).substring(2, 12);
Sentry.setTag("errorId", sessionId);
export default sessionId;
